import { render } from "./dondeycuando_ingles.vue?vue&type=template&id=b854d408&scoped=true"
import script from "./dondeycuando_ingles.vue?vue&type=script&lang=js"
export * from "./dondeycuando_ingles.vue?vue&type=script&lang=js"

import "./dondeycuando_ingles.vue?vue&type=style&index=0&id=b854d408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b854d408"]])

export default __exports__